import { render, staticRenderFns } from "./DepartmentSetting.vue?vue&type=template&id=51ba0803&"
import script from "./DepartmentSetting.vue?vue&type=script&lang=js&"
export * from "./DepartmentSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports